import { CaretRight } from "@phosphor-icons/react";
import { type AnchorHTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/cn";

export type BreadcrumbItem = {
  label: ReactNode;
  href?: string;
  onClick?: AnchorHTMLAttributes<HTMLAnchorElement>["onClick"];
};

export type BreadcrumbsProps = {
  items: BreadcrumbItem[];
  className?: string;
};

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="bfrs-flex bfrs-flex-wrap bfrs-items-center bfrs-gap-1 bfrs-text-sm bfrs-text-text-muted">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="bfrs-flex bfrs-items-center bfrs-gap-1">
              {item.href && !isLast ? (
                <a href={item.href} onClick={item.onClick} className="bfrs-rounded-sm hover:bfrs-text-text-primary focus-visible:bfrs-outline-none focus-visible:bfrs-ring-2 focus-visible:bfrs-ring-border-focus">
                  {item.label}
                </a>
              ) : (
                <span className={cn(isLast && "bfrs-font-medium bfrs-text-text-primary")}>{item.label}</span>
              )}
              {!isLast && <CaretRight size={12} aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
